module.exports = __webpack_public_path__ + "img/pipe-7.33a96f1e.jpg";